/* QC2: one small lazy video player for every .vid box (snippets/srx-vid.liquid).
   Nothing is downloaded until it is needed:
   - tap / click the play button: the video (or YouTube embed) loads and plays inline with sound;
   - hover (desktop mouse only, not under prefers-reduced-motion): a muted looping preview.
   Event delegation, so it also works after the theme editor re-renders a section. */
(function () {
  if (window.srxVid) return;
  window.srxVid = true;

  var hoverOk = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches &&
    !matchMedia('(prefers-reduced-motion: reduce)').matches;

  function videoFor(box) {
    var v = box.querySelector('video');
    if (!v) {
      v = document.createElement('video');
      v.className = 'vid__media';
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.preload = 'auto';
      v.src = box.getAttribute('data-vid-src');
      v.addEventListener('ended', function () {
        if (box.classList.contains('is-playing')) stop(box);
      });
      box.insertBefore(v, box.firstChild);
    }
    return v;
  }

  /* QC4: one video at a time across the whole page. A YouTube box keeps its player on screen and is
     paused through the IFrame API (enablejsapi=1); an MP4 box goes back to its poster. Any other
     <video> or JS-API YouTube iframe on the page (review-wall dialog, legacy sections) is paused too. */
  function ytCommand(f, func) {
    try { f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*'); } catch (e) {}
  }

  function stop(box) {
    var f = box.querySelector('iframe');
    if (f) { ytCommand(f, 'pauseVideo'); box.classList.remove('is-hover'); return; }
    var v = box.querySelector('video');
    if (v) { v.pause(); v.controls = false; }
    box.classList.remove('is-playing', 'is-hover');
  }

  function stopOthers(keep) {
    var boxes = document.querySelectorAll('.vid.is-playing');
    for (var i = 0; i < boxes.length; i++) if (boxes[i] !== keep) stop(boxes[i]);
    var vids = document.querySelectorAll('video');
    for (var j = 0; j < vids.length; j++) {
      var v = vids[j];
      if (keep && keep.contains(v)) continue;
      if (!v.paused && !v.muted) v.pause();
    }
    var frames = document.querySelectorAll('iframe[src*="enablejsapi=1"]');
    for (var k = 0; k < frames.length; k++) if (!(keep && keep.contains(frames[k]))) ytCommand(frames[k], 'pauseVideo');
  }
  window.srxPauseOthers = stopOthers;

  /* any <video> that starts with sound (also ones this file doesn't own) pauses the rest */
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || v.muted) return;
    stopOthers(v.closest('.vid') || v);
  }, true);

  /* a YouTube player started from its own controls tells us through the IFrame API */
  window.addEventListener('message', function (e) {
    if (!/^https:\/\/www\.youtube(-nocookie)?\.com$/.test(e.origin)) return;
    var d; try { d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (err) { return; }
    if (!d) return;
    var state = d.event === 'onStateChange' ? d.info : (d.event === 'infoDelivery' && d.info ? d.info.playerState : null);
    if (state !== 1) return;
    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === e.source) { stopOthers(frames[i].closest('.vid') || frames[i]); return; }
    }
  });

  function ytListen(f) {
    f.addEventListener('load', function () {
      try { f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }), '*'); } catch (e) {}
    });
  }

  function safePlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function play(box) {
    stopOthers(box);
    var yt = box.getAttribute('data-vid-yt');
    if (yt) {
      var f = box.querySelector('iframe');
      if (f) { ytCommand(f, 'playVideo'); }
      else {
        f = document.createElement('iframe');
        f.className = 'vid__media';
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1&enablejsapi=1&origin=' + encodeURIComponent(location.origin);
        ytListen(f);
        f.title = box.getAttribute('data-vid-label') || 'Video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        box.appendChild(f);
      }
      box.classList.add('is-playing');
      return;
    }
    var v = videoFor(box);
    var fromHover = box.classList.contains('is-hover');
    box.classList.remove('is-hover');
    box.classList.add('is-playing');
    if (!fromHover) v.currentTime = 0;
    v.loop = false;
    v.muted = false;
    v.controls = true;
    safePlay(v);
    try { v.focus({ preventScroll: true }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.vid__play');
    if (btn) { e.preventDefault(); play(btn.closest('.vid')); return; }
    var more = e.target.closest && e.target.closest('[data-vid-more]');
    if (more) {
      var grid = document.getElementById(more.getAttribute('aria-controls'));
      if (grid) grid.classList.add('is-open');
      more.hidden = true;
    }
  });

  if (!hoverOk) return;

  document.addEventListener('mouseover', function (e) {
    var box = e.target.closest && e.target.closest('.vid[data-vid-hover][data-vid-src]');
    if (!box || box.classList.contains('is-playing') || box.classList.contains('is-hover')) return;
    if (e.relatedTarget && box.contains(e.relatedTarget)) return;
    var v = videoFor(box);
    v.muted = true;
    v.loop = true;
    box.classList.add('is-hover');
    safePlay(v);
  });

  document.addEventListener('mouseout', function (e) {
    var box = e.target.closest && e.target.closest('.vid.is-hover');
    if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
    var v = box.querySelector('video');
    if (v) v.pause();
    box.classList.remove('is-hover');
  });
})();
